import { STATION_COMMON_NAME_COOKIE } from "@/lib/constants"
import Cookies from "js-cookie"

interface TermsForPromoType {
  predicates: Array<boolean | undefined>,
  terms: string[]
}

export const TERMS_FOR_PROMOTIONS: { [key: string]: TermsForPromoType } = {
  passport: {
    predicates: [
      Cookies.get(STATION_COMMON_NAME_COOKIE) !== undefined
    ],
    terms: [
    'passport',
    'sponsorship',
  ]},
  activate: {
    predicates: [],
    terms: [
    'activate',
    'acitvate',
    'activation',
    'roku',
    'activate roku',
    'apple tv',
    'activate apple tv',
    'samsung',
    'activate samsung',
    'activate samsung tv',
    'fire tv',
    'pbs.org/activate',
  ]},
  foundation: {
    predicates: [],
    terms: [
    'pbs foundation',
    'foundation'
  ]},
  kids: {
    predicates: [],
    terms: [
    'pbs kids',
    'pbskids',
    'kids'
  ]}
}

export type TERMS_KEYS_TYPE = keyof typeof TERMS_FOR_PROMOTIONS
export type TERMS_KEYS_VALUES_TYPE = `${TERMS_KEYS_TYPE}`

export const PUBLISHED_TEST_DATA_SLUGS = [
  'koth-show',
  'koth-franchise',
  'press-exclusives',
  'fundraising-extras',
]

export const DISQUALIFYING_FILTERS = [
  "filter_video_type",
  "filter_duration",
  "filter_show",
  "filter_video_availability",
  "filter_descriptive",
]

const stationName = Cookies.get(STATION_COMMON_NAME_COOKIE)

export interface PromotedResultType {
  title: string;
  description: string;
  item_type: string;
  external_url: string;
  image_url: string;
  promoted: boolean;
}

export const PROMOTED_RESULTS: { [key: string]: PromotedResultType[] }  = {
  passport: [{
      title: `Learn More About ${stationName} | Passport`,
      description: `${stationName} | Passport is an added membership benefit that provides extended on-demand access to quality PBS programming.`,
      item_type: "remote_asset",
      external_url: "https://www.pbs.org/passport/learn-more/",
      image_url: `/images/results/pbs-logotype--promoted-search.png`,
      promoted: true,
  },{
    title: `${stationName} | Passport Videos`,
    description: `Explore the best of ${stationName} | Passport. Enjoy your favorite dramas, food, history shows plus much more.`,
    item_type: "remote_asset",
    external_url: '/explore/passport',
    image_url: `/images/results/pbs-logotype--promoted-search.png`,
    promoted: true,
  }],

  sponsorship: [{
      title: "Learn More About National Corporate Sponsorship | PBS National Sales",
      description: "PBS Sponsorship is the most effective and efficient way to harness the power of the PBS brand to reach an engaged audience on multiple platforms.",
      item_type: "remote_asset",
      external_url: "https://www.pbs.org/sponsorship/",
      image_url: `/images/results/pbs-logotype--promoted-search.png`,
      promoted: true,
  }],

  activate: [{
    title: "PBS Device Activation",
    description: "Activate the PBS App on your device so that you can watch award-winning national programming and locally produced shows. Catch up on the episodes you may have missed and watch your favorite, full-length shows free and on-demand.",
    item_type: "remote_asset",
    // @TODO: update this to point at /tv/ once new device activation is live
    external_url: "https://www.pbs.org/activate/",
    image_url: `/images/results/pbs-logotype--promoted-search.png`,
    promoted: true,
  }],

  foundation: [{
    title: "PBS Foundation",
    description: "Support PBS by donating to the PBS Foundation, PBS’s national fundraising entity.",
    item_type: "remote_asset",
    external_url: "https://www.pbs.org/foundation/",
    image_url: `/images/results/pbs-logotype--promoted-search.png`,
    promoted: true,
  }],

  kids: [{
    title: "PBS KIDS",
    description: "Educational games and videos from Daniel Tiger’s Neighborhood, Wild Kratts, and more.",
    item_type: "remote_asset",
    external_url: "https://pbskids.org/",
    image_url: `/images/results/PBS_KIDS_logo.svg`,
    promoted: true,
  }]
}
